import { ITabsListProps } from "src/components-mui/tabs/tabs-list";
import Typography from "src/theme/typography";

export const getTabsListCustomVariantStyles = (variant: ITabsListProps["customVariant"]) => {
    switch (variant) {
        case "pills": {
            return {
                width: "100%",
                height: "auto",
                minHeight: "unset",

                "& .MuiTabs-list": {
                    display: "flex",
                    gap: "8px",
                },

                "& .MuiTab-root": {
                    height: "32px",
                    minHeight: "unset",
                    padding: "0 16px 0 16px",
                    fontWeight: Typography.fontWeights.bold,
                    color: "var(--mui-palette-gray-400)",
                    textTransform: "none",
                    transition: "background-color 0.2s",
                    borderRadius: "16px",
                    minWidth: "unset",
                },

                "& .MuiTab-root:hover": {
                    backgroundColor: "var(--mui-palette-gray-50)",
                },

                "& .MuiTab-root.Mui-selected": {
                    backgroundColor: "var(--mui-palette-gray-800)",
                    color: "#ffffff",
                },

                "& .MuiTabs-indicator": {
                    display: "none",
                },
            };
        }
        case "full":
        default: {
            return {
                backgroundColor: "var(--mui-palette-gray-100)",
                width: "100%",
                height: "40px",
                minHeight: "unset",
                borderRadius: "6px",

                "& .MuiTabs-list": {
                    width: "100%",
                    display: "flex",
                },

                "& .MuiTabs-root": {
                    width: "100%",
                },

                "& .MuiTab-root": {
                    flex: 1,
                    maxWidth: "none",
                    width: "100%",
                    flexBasis: 0,
                    flexGrow: 1,
                    flexShrink: 1,
                    height: "32px",
                    minWidth: "fit-content",
                    minHeight: "unset",
                    padding: 0,
                    fontWeight: Typography.fontWeights.bold,
                    color: "var(--mui-palette-gray-600)",
                    textTransform: "none",
                    transition: "background-color 0.2s",
                    borderRadius: "4px",
                    overflow: "visible",
                },

                "& .MuiTabs-scroller": {
                    padding: "4px",
                    width: "100%",
                    display: "flex",
                },

                "& .MuiTab-root.Mui-selected": {
                    backgroundColor: "#ffffff",
                    color: "var(--mui-palette-gray-800)",
                },

                "& .MuiTabs-indicator": {
                    display: "none",
                },
            };
        }
    }
};
